import { FeatureFlags as CatalogFeatureFlags } from '@tableau/catalog-core';
import { defaultMemoize } from 'reselect';

import { FeatureFlags as VizportalClientFeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

// This object is lazy-loaded because the feature flags aren't fully set up until after the app login
export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return {
    metricsDataCatalogEnabled: VizportalClientFeatureFlags.metricsDataCatalogEnabled,
    writableFieldDescriptionsEnabled: VizportalClientFeatureFlags.writableFieldDescriptionsEnabled,
    fieldDescriptionInheritanceLineageEnabled: VizportalClientFeatureFlags.fieldDescriptionInheritanceLineageEnabled,
    publishedConnectionsLineageEnabled: VizportalClientFeatureFlags.publishedConnectionsLineageEnabled,
    databasesInProjectsEnabled: VizportalClientFeatureFlags.databasesInProjectsEnabled,
    lensLineageEnabled: VizportalClientFeatureFlags.askDataLensesInCatalogEnabled,
    relevantAssetsEnabled: VizportalClientFeatureFlags.relevantAssetsEnabled,
    mixedContentConnectToDialogEnabled: VizportalClientFeatureFlags.mixedContentConnectToDialogEnabled,
    searchAndFilterOnLineagePageEnabled: VizportalClientFeatureFlags.searchAndFilterOnLineagePageEnabled,
    dataCloudInCatalogMVPEnabled: VizportalClientFeatureFlags.dataCloudInCatalogMVPEnabled,
    customLabelCategoriesEnabled: VizportalClientFeatureFlags.customLabelCategoriesEnabled,
    suggestDescriptionsEnabled: VizportalClientFeatureFlags.suggestDescriptionsEnabled,
    pulseInDataCatalogEnabled: VizportalClientFeatureFlags.pulseInDataCatalogEnabled,
  };
});
